// @flow
import React from 'react';
import { fromNow } from 'lib/common';
import { Link } from 'react-router-dom';
import cx from 'classnames';
import 'moment/locale/ko';
import './LetterCard.scss';

type Props = {
  id: string,
  thumbnail: string,
  username: string,
  title: string,
  urlSlug: string,
  oneColumn?: boolean,
  shortDescription: string,
};

const LetterCard = ({ thumbnail, title, urlSlug, oneColumn, shortDescription }: Props) => {
  const link = `/@cacheby/letters/${urlSlug}`;
  return (
    <div className={cx('LetterCard', { 'one-column': oneColumn })}>
      <Link to={link} className="letter-card-link">
        <div className="card-content">
          <div className="content-header">
            <h3 className="letter-title">{title}</h3>
            <div className="letter-meta">
              <span className="letter-badge" role="img" aria-label="뉴스레터">
                ✉️ 뉴스레터
              </span>
            </div>
          </div>
          <div className="letter-description">
            {shortDescription}
          </div>
        </div>
      </Link>
    </div>
  );
};

LetterCard.defaultProps = {
  oneColumn: false,
};

export default LetterCard;



// WEBPACK FOOTER //
// ./src/components/common/LetterCard/LetterCard.js